import React, { useState, useEffect, useRef } from 'react';
import { Navigate } from "react-router-dom";
import {
  ArrowBack,
} from "@mui/icons-material";
import { Button, Fab, Tooltip } from "@mui/material";

import Grid from '@mui/material/Grid2';

import { AbilityEffect, Condition, Potence, RollPlusUpgradable, Spell, SpellList } from "@dndModels";
import { AreaType, DamageType, isDamageType, isSchoolOfMagic, SpellLevel } from "@dndModels/Types";
import { makeStyles } from "@utilities/theme_utilities";
import { AREA_TYPES, DAMAGE_TYPES } from "@dndModels/Constants";

import API from "@dndUtilities/system_api";
import CommonUtilities from "@utilities/common_utilities";
// import DandDCharacterUtilities from '../../utilities/character_utilities';

import StringBox from "@components/input/strings/StringBox";
import LoadingBox from "@components/input/LoadingBox";
import ViewSpell from "@dndComponents/display/ViewSpell";
import DeleteButton from "@components/input/buttons/icon_buttons/DeleteButton";
import SpellDetails from "@dndComponents/display/SpellDetails";
import SpellEffects from "@dndComponents/other/SpellEffects";
import DisplayObjects from "@dndComponents/display/DisplayObjects";
import CheckBox from "@components/input/CheckBox";
import SelectSourceBookBox from '@dndComponents/select/SelectSourceBookBox';

const api = API.getInstance();
const common_util = CommonUtilities.getInstance();

export default function SpellParseAdd() {
  const [loading, setLoading] = useState(false);
  const [fetched, setFetched] = useState(false);
  const [spell_lists, setSpellLists] = useState<SpellList[]>([]);
  const [old_spells, setOldSpells] = useState<Spell[]>([]);
  const [conditions, setConditions] = useState<Condition[]>([]);
  const [navigateTo, setNavigateTo] = useState<string | null>(null);
  const [parse_string, setParseString] = useState("");
  const [processing, setProcessing] = useState(false);
  const [complete, setComplete] = useState(false);
  const [processing_message, setProcessingMessage] = useState("");
  const [spells, setSpells] = useState<Spell[]>([]);
  const [expanded_spell, setExpandedSpell] = useState("");
  const [ping, setPing] = useState(false);
  const [make_dominant, setMakeDominant] = useState(false);
  const [final_report, setFinalReport] = useState<string[]>([]);
  const [sl_sb_type, setSLSBType] = useState(api.working_on_sb?.source_book_type??"Source Book");
  const [sl_sb_id, setSLSBId] = useState(api.working_on_sb?._id??"");

  const parseRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if(!fetched) {
      load();
    }
  });
  
  const load = () => {
    setLoading(true);
    api.getSetOfObjects({ data_types: ["spell_list","condition","spell"]}).then(res => {
      setSpellLists(res.spell_list as SpellList[]);
      setConditions((res.condition as Condition[]).filter(o => o.common));
      setOldSpells(res.spell as Spell[]);
      setLoading(false);
    });
    setFetched(true);
  }
  
  const useStyles = makeStyles()((theme) => {
    // console.log(theme);
    return ({
      root: {
        backgroundColor: theme.palette.secondary.main
      },
    });
  });

  const { classes, cx } = useStyles();

  const submit = (error_messages: string[] = []) => {
    const next_spell = spells.find(o => o._id === "");
    if (next_spell) {
      // if (make_dominant && next_spell.variant_group.length > 0) {
      //   const max_dominance_level = Math.max(...next_spell.variant_group.map(o => o.dominance_level));
      //   next_spell.dominance_level = max_dominance_level + 1;
      // }
      if (next_spell.parse_errors.length > 0) {
        error_messages.push(...next_spell.parse_errors.map(o => {
          return `${next_spell.name}: ${o}`;
        }));
      }
      setProcessingMessage(`Saving ${next_spell.name}`);
      api.upsertObject("spell", next_spell).then(res => {
        console.log(res);
        if (res && res.body.id) {
          next_spell._id = res.body.id;
        } else {
          next_spell._id = "Error";
          error_messages.push(`${next_spell.name} Save Failed`);
        }
        submit(error_messages);
      });
    } else {
      handleSpellLists([], error_messages);
    }
  }

  const handleSpellLists = (saved_spell_lists: string[], error_messages: string[]) => {
    const next_spell_list = spell_lists.find(o => !saved_spell_lists.includes(o._id));
    if (next_spell_list) {
      setProcessingMessage(`Saving ${next_spell_list.name} Spell List`);
      next_spell_list.pushSpellIds([...spells.filter(o => 
        o._id !== "Error" && o.spell_list_ids.includes(next_spell_list._id)).map(o => o._id)], sl_sb_id);
      api.upsertObject("spell_list", next_spell_list).then(res => {
        console.log(res);
        handleSpellLists([...saved_spell_lists,next_spell_list._id], error_messages);
      });
    } else {
      setFinalReport(error_messages);
      setProcessing(false);
      setComplete(true);
    }
  }

  // const parse = () => {
  //   // setProcessing(true);
  //   // setProcessingMessage("Getting Started");
    
  //   // debugger;
  //   let elem = parseRef.current as HTMLElement;
  //   while (elem instanceof HTMLDivElement && elem.children.length < 2) {
  //     elem = elem.children[0] as HTMLElement;
  //   }
  //   // First we need to separate the contents into the individual spells
  //   const new_spells: Spell[] = [];
  //   let i = 0;
  //   // Getting past the stuff above the first one.
  //   while (i < elem.children.length) {
  //     const child = elem.children[i];
  //     ++i;
  //     if (child instanceof HTMLElement && child.className.includes("compendium-hr heading-anchor")) {
  //       // Next is the first spell
  //       break;
  //     }
  //   }
  //   let current_spell = new Spell();

  //   const addSpell = () => {
  //     if (current_spell.name.length > 0) {
  //       const possible_variants = old_spells.filter(o => o.name === current_spell.name);
  //       let variant_group_ids: string[] = [];
  //       for (const pv of possible_variants) {
  //         variant_group_ids.push(pv.variant_group_id);
  //         current_spell.variant_ids = [...pv.variant_ids,...current_spell.variant_ids];
  //       }
  //       variant_group_ids = common_util.unique_array(variant_group_ids);
  //       current_spell.variant_ids = common_util.unique_array(current_spell.variant_ids);
  //       if (variant_group_ids.length === 1) {
  //         current_spell.variant_of_id = variant_group_ids[0];
  //         current_spell.variant_group = possible_variants;
  //       }
        
  //       if (api.working_on_sb) {
  //         const sb_id = api.working_on_sb._id;
  //         current_spell.source_books_old = [{ id: api.working_on_sb._id, type: api.working_on_sb.source_book_type, third_party: api.working_on_sb.third_party }];
  //         if (possible_variants.filter(o => o.source_book_ids.includes(sb_id)).length > 0) {
  //           current_spell.parse_errors.push("Variant on Book Already Exists.");
  //         }
  //       }

  //       current_spell.description = common_util.cleanStringSpaces(current_spell.description);

  //       let main_description = current_spell.description;
  //       let upgrade_description = "";
        
  //       if (current_spell.description.includes("Cantrip Upgrade.") && !current_spell.description.includes("<b>")) {
  //         upgrade_description = main_description.substring(main_description.indexOf("Cantrip Upgrade."));
  //         main_description = main_description.substring(0, main_description.indexOf("Cantrip Upgrade.") - 1);
  //         current_spell.description = current_spell.description.replace("Cantrip Upgrade.", "<b>Cantrip Upgrade.</b>");
  //       } else if (current_spell.description.includes("Using a Higher-Level Spell Slot.") && !current_spell.description.includes("<b>")) {
  //         upgrade_description = main_description.substring(main_description.indexOf("Using a Higher-Level Spell Slot."));
  //         main_description = main_description.substring(0, main_description.indexOf("Using a Higher-Level Spell Slot.") - 1);
  //         current_spell.description = current_spell.description.replace("Using a Higher-Level Spell Slot.", "<b>Using a Higher-Level Spell Slot.</b>");
  //       } 

  //       if (current_spell.effects.length === 0) {
  //         current_spell.effects.push(new AbilityEffect());
  //       }
  //       const effect = current_spell.effects[0];
  //       const desc_pieces = main_description.toLocaleLowerCase().split(" ");
  //       if (main_description.includes("damage")) {
  //         // if (current_spell.name.includes("Disintegrate")) {
  //         //   debugger;
  //         // }
  //         let good = false;
  //         let roll = new RollPlusUpgradable();
  //         let look_in = [...desc_pieces];
  //         while (look_in.length > 0) {
  //           const index = look_in.findIndex(str => str.includes("damage"));
  //           if (index < 0) {
  //             break; // It reached the end.  Break or it will infinite loop.
  //           }
  //           // It's almost always written as `${potence_string} ${dt_string} damage`
  //           // Disintegrate is't like this: target takes 10d6 + 40 Force damage.
  //           const dt_string = common_util.capitalize_first(look_in[index - 1]);
  //           let potence_string = look_in[index - 2];
  //           if (!potence_string.includes("d") && !isNaN(+potence_string)) {
  //             // 10d6 + 40 Force damage.
  //             if (look_in[index - 3] === "plus" || look_in[index - 3] === "+") {
  //               potence_string = look_in[index - 4] + " " + look_in[index - 3] + " " + potence_string;
  //             }
  //           }
  //           if (isDamageType(dt_string)) {
  //             if (!effect.damage_types.includes(dt_string as DamageType)) {
  //               effect.damage_types.push(dt_string as DamageType);
  //             }
  //             roll = common_util.parse_dice_roll_upgradable(potence_string);
  //             if (roll.isBlank()) {
  //               look_in = look_in.slice(index + 1);
  //             } else {
  //               good = true;
  //               break;
  //             }
  //             // const potence_pieces = potence_string.split("d");
  //             // if (potence_pieces.length === 2) {
  //             //   count = +potence_pieces[0];
  //             //   size = +potence_pieces[1];
  //             //   if (!isNaN(count) && !isNaN(size)) {
  //             //     good = true;
  //             //     break;
  //             //   } else {
  //             //     look_in = look_in.slice(index + 1);
  //             //   }
  //             // } 
  //           } else if (!isDamageType(dt_string)) {
  //             // It's possible that dt_string is actually potence_string. In that case make it Typeless
  //             if (dt_string.includes("d")) {
  //               roll = common_util.parse_dice_roll_upgradable(dt_string);
  //               if (roll.isBlank()) {
  //                 look_in = look_in.slice(index + 1);
  //               } else {
  //                 good = true;
  //                 break;
  //               }
  //               // const potence_pieces = dt_string.split("d");
  //               // if (potence_pieces.length === 2) {
  //               //   count = +potence_pieces[0];
  //               //   size = +potence_pieces[1];
  //               //   if (!isNaN(count) && !isNaN(size)) {
  //               //     if (effect.damage_types.length === 0) {
  //               //       effect.damage_types.push("Typeless");
  //               //     }
  //               //     good = true;
  //               //     break;
  //               //   } else {
  //               //     look_in = look_in.slice(index + 1);
  //               //   }
  //               // }  else {
  //               //   look_in = look_in.slice(index + 1);
  //               // }
  //             } else {
  //               look_in = look_in.slice(index + 1);
  //             }
  //           } else {
  //             look_in = look_in.slice(index + 1);
  //           }
  //         }
  //         if (!good) {
  //           // On a hit, the target takes Psychic damage equal to 
  //           // 3d12 plus your spellcasting ability modifier, 
  //           look_in = [...desc_pieces];
  //           while (look_in.length > 0) {
  //             const index = look_in.findIndex(str => str.includes("damage"));
  //             if (index < 0) {
  //               break; // It reached the end.  Break or it will infinite loop.
  //             }
  //             if (look_in[index + 1] === "equal" && look_in[index + 2] === "to") {
  //               const dt_string = common_util.capitalize_first(look_in[index - 1]);
  //               if (isDamageType(dt_string)) {
  //                 if (!effect.damage_types.includes(dt_string as DamageType)) {
  //                   effect.damage_types.push(dt_string as DamageType);
  //                 }
  //               }
  //               let potence_string = look_in[index + 3];
  //               if (look_in[index + 4] === "plus" || look_in[index + 4] === "+") {
  //                 potence_string += " " + look_in[index + 4];
  //                 let j = index + 5;
  //                 while (j < look_in.length) {
  //                   potence_string += " " + look_in[j];
  //                   if (look_in[j].includes(".") || look_in[j].includes(",")) {
  //                     break;
  //                   }
  //                   ++j;
  //                 }
  //               }
  //               roll = common_util.parse_dice_roll_upgradable(potence_string);
  //               if (roll.isBlank()) {
  //                 look_in = look_in.slice(index + 1);
  //               } else {
  //                 good = true;
  //                 break;
  //               }
  //             } else {
  //               look_in = look_in.slice(index + 1);
  //             }
  //           }
  //         }
  //         if (good) {
  //           effect.type = "Damage";
  //           const potence = new Potence();
  //           if (current_spell.level > 0) {
  //             potence.level = current_spell.level;
  //           } else {
  //             effect.potence_type = "Character";
  //             potence.level = 1;
  //           }
  //           potence.rolls = roll;
  //           // potence.rolls.count.base = count;
  //           // potence.rolls.size.base = size;
  //           effect.potences.push(potence);
  //           if (upgrade_description.includes("Higher-Level Spell Slot")) {
  //             if (upgrade_description.includes("increases by")) {
  //               // The damage increases by 1d8 for each spell slot level above 4.
  //               let word = upgrade_description.substring(upgrade_description.indexOf("increases by ") + 13).trim();
  //               word = word.substring(0, word.indexOf(" ")).trim();
  //               const roll = common_util.parse_dice_roll(word);
  //               if (potence.rolls.size.base === roll.size || (roll.count === 0 && potence.rolls.size.base === 0)) {
  //                 let last_p = potence;
  //                 for (let j = current_spell.level + 1; j < 10; ++j) {
  //                   const p = last_p.clone(true);
  //                   p.level = j;
  //                   if (roll.count === 0) {
  //                     p.rolls.flat.base += roll.flat;
  //                   } else {
  //                     p.rolls.count.base += roll.count;
  //                   }
  //                   effect.potences.push(p);
  //                   last_p = p;
  //                 }
  //               }
  //             }
  //           } else if (upgrade_description.includes("Cantrip Upgrade")) {
  //             if (upgrade_description.includes("increases by")) {
  //               // The damage increases by 1d6 when you reach levels 5 (2d6), 11 (3d6), and 17 (4d6).
  //               let word = upgrade_description.substring(upgrade_description.indexOf("increases by ") + 13).trim();
  //               word = word.substring(0, word.indexOf(" ")).trim();
  //               const roll = common_util.parse_dice_roll(word);
  //               if (potence.rolls.size.base === roll.size || (roll.count === 0 && potence.rolls.size.base === 0)) {
  //                 const p5 = potence.clone(true);
  //                 p5.level = 5;
  //                 if (roll.count === 0) {
  //                   p5.rolls.flat.base += roll.flat;
  //                 } else {
  //                   p5.rolls.count.base += roll.count;
  //                 }
  //                 effect.potences.push(p5);
  //                 const p11 = p5.clone(true);
  //                 p11.level = 11;
  //                 if (roll.count === 0) {
  //                   p11.rolls.flat.base += roll.flat;
  //                 } else {
  //                   p11.rolls.count.base += roll.count;
  //                 }
  //                 effect.potences.push(p11);
  //                 const p17 = p11.clone(true);
  //                 p17.level = 17;
  //                 if (roll.count === 0) {
  //                   p17.rolls.flat.base += roll.flat;
  //                 } else {
  //                   p17.rolls.count.base += roll.count;
  //                 }
  //                 effect.potences.push(p17);
  //               }
  //             }
  //           }
  //           if (effect.damage_types.length === 0) {
  //             // This is generally a situation where it has multiple damage types, listed in a different spot.
  //             // Just search for them.
  //             for (const dt of DAMAGE_TYPES) {
  //               if (main_description.includes(dt)) {
  //                 effect.damage_types.push(dt as DamageType);
  //               }
  //             }
  //           }
  //           if (effect.damage_types.length === 0) {
  //             current_spell.parse_errors.push("Unable to find Damage Types.");
  //           }
  //         } else {
  //           current_spell.parse_errors.push("Damage string format not matching.");
  //           console.error("Damage string format not matching.");
  //           console.error(main_description);
  //         }
  //       }
  //       if (effect.attack_type === "None") {
  //         if (main_description.includes("melee spell attack")) {
  //           effect.attack_type = "Melee Spell";
  //         } else if (main_description.includes("ranged spell attack")) {
  //           effect.attack_type = "Ranged Spell";
  //         } else if (main_description.includes("melee attack")) {
  //           effect.attack_type = "Melee";
  //         } else if (main_description.includes("ranged attack")) {
  //           effect.attack_type = "Ranged";
  //         } else {
  //           // if (current_spell.name.includes("Blight")) {
  //           //   debugger;
  //           // }
  //           if (desc_pieces.includes("saving")) {
  //             let index = desc_pieces.findIndex(o => o === "saving");
  //             const prev = desc_pieces[index - 1];
  //             switch (prev) {
  //               case "strength": 
  //                 effect.attack_type = "Save";
  //                 effect.saving_throw_ability_score = "STR"; 
  //               break;
  //               case "dexterity": 
  //                 effect.attack_type = "Save";
  //                 effect.saving_throw_ability_score = "DEX"; 
  //               break;
  //               case "constitution": 
  //                 effect.attack_type = "Save";
  //                 effect.saving_throw_ability_score = "CON"; 
  //               break;
  //               case "intelligence": 
  //                 effect.attack_type = "Save";
  //                 effect.saving_throw_ability_score = "INT"; 
  //               break;
  //               case "wisdom": 
  //                 effect.attack_type = "Save";
  //                 effect.saving_throw_ability_score = "WIS"; 
  //               break;
  //               case "charisma": 
  //                 effect.attack_type = "Save";
  //                 effect.saving_throw_ability_score = "CHA"; 
  //               break;
  //             }
  //           } else if (desc_pieces.includes("save")) {
  //             let index = desc_pieces.findIndex(o => o === "save");
  //             const prev = desc_pieces[index - 1];
  //             switch (prev) {
  //               case "strength": 
  //                 effect.attack_type = "Save";
  //                 effect.saving_throw_ability_score = "STR"; 
  //               break;
  //               case "dexterity": 
  //                 effect.attack_type = "Save";
  //                 effect.saving_throw_ability_score = "DEX"; 
  //               break;
  //               case "constitution": 
  //                 effect.attack_type = "Save";
  //                 effect.saving_throw_ability_score = "CON"; 
  //               break;
  //               case "intelligence": 
  //                 effect.attack_type = "Save";
  //                 effect.saving_throw_ability_score = "INT"; 
  //               break;
  //               case "wisdom": 
  //                 effect.attack_type = "Save";
  //                 effect.saving_throw_ability_score = "WIS"; 
  //               break;
  //               case "charisma": 
  //                 effect.attack_type = "Save";
  //                 effect.saving_throw_ability_score = "CHA"; 
  //               break;
  //             }
  //           }
  //         }
  //       }
  //       for (const area_type of AREA_TYPES as AreaType[]) {
  //         if (desc_pieces.includes(area_type.toLocaleLowerCase())) {
  //           let good = false;
  //           if (area_type === "Circle" || 
  //             area_type === "Sphere") {
  //             let radius_index = desc_pieces.findIndex(o => o === "radius");
  //             if (radius_index < 0) {
  //               radius_index = desc_pieces.findIndex(o => o.includes("radius"));
  //             }
  //             if (radius_index > 0) {
  //               let radius = 0;
  //               if (desc_pieces[radius_index].includes("-")) {
  //                 const area_pieces = desc_pieces[radius_index].split("-");
  //                 radius = +area_pieces[0];
  //               } else {
  //                 radius = +desc_pieces[radius_index - 1];
  //                 if (isNaN(radius) && desc_pieces[radius_index - 1].includes("-")) {
  //                   const area_pieces = desc_pieces[radius_index - 1].split("-");
  //                   radius = +area_pieces[0];
  //                 }
  //                 if (isNaN(radius)) {
  //                   radius = +desc_pieces[radius_index - 2];
  //                 }
  //               }
  //               if (!isNaN(radius)) {
  //                 good = true;
  //                 effect.target_int.area.base = radius;
  //               }
  //             } else {
  //               let diameter_index = desc_pieces.findIndex(o => o === "diameter");
  //               if (diameter_index < 0) {
  //                 diameter_index = desc_pieces.findIndex(o => o.includes("diameter"));
  //               }
  //               if (diameter_index > 0) {
  //                 let diameter = 0;
  //                 if (desc_pieces[diameter_index].includes("-")) {
  //                   const area_pieces = desc_pieces[diameter_index].split("-");
  //                   diameter = +area_pieces[0];
  //                 } else {
  //                   diameter = +desc_pieces[diameter_index - 1];
  //                   if (isNaN(diameter) && desc_pieces[diameter_index - 1].includes("-")) {
  //                     const area_pieces = desc_pieces[diameter_index - 1].split("-");
  //                     diameter = +area_pieces[0];
  //                   }
  //                   if (isNaN(diameter)) {
  //                     diameter = +desc_pieces[diameter_index - 2];
  //                   }
  //                 }
  //                 if (!isNaN(diameter)) {
  //                   good = true;
  //                   effect.target_int.area.base = diameter / 2;
  //                 }
  //               }
  //             }
  //           } else if (area_type === "Cylinder") {
  //             // Cylinder that is 10 feet tall with a 60-foot radius.
  //             let radius_index = desc_pieces.findIndex(o => o === "radius");
  //             if (radius_index < 0) {
  //               radius_index = desc_pieces.findIndex(o => o.includes("radius"));
  //             }
  //             let high_index = desc_pieces.findIndex(o => o === "high");
  //             if (high_index < 0) {
  //               high_index = desc_pieces.findIndex(o => o.includes("high"));
  //             }
  //             if (high_index < 0) {
  //               high_index = desc_pieces.findIndex(o => o === "tall");
  //               if (high_index < 0) {
  //                 high_index = desc_pieces.findIndex(o => o.includes("tall"));
  //               }
  //             }
  //             if (radius_index > 0 && high_index > 0) {
  //               let radius = 0;
  //               let high = 0;
  //               if (desc_pieces[radius_index].includes("-")) {
  //                 const area_pieces = desc_pieces[radius_index].split("-");
  //                 radius = +area_pieces[0];
  //               } else {
  //                 radius = +desc_pieces[radius_index - 1];
  //                 if (isNaN(radius) && desc_pieces[radius_index - 1].includes("-")) {
  //                   const area_pieces = desc_pieces[radius_index - 1].split("-");
  //                   radius = +area_pieces[0];
  //                 }
  //                 if (isNaN(radius)) {
  //                   radius = +desc_pieces[radius_index - 2];
  //                 }
  //               }
  //               if (desc_pieces[high_index].includes("-")) {
  //                 const area_pieces = desc_pieces[high_index].split("-");
  //                 high = +area_pieces[0];
  //               } else {
  //                 high = +desc_pieces[high_index - 1];
  //                 if (isNaN(high) && desc_pieces[high_index - 1].includes("-")) {
  //                   const area_pieces = desc_pieces[high_index - 1].split("-");
  //                   high = +area_pieces[0];
  //                 }
  //                 if (isNaN(high)) {
  //                   high = +desc_pieces[high_index - 2];
  //                 }
  //               }
  //               if (!isNaN(radius) && !isNaN(high)) {
  //                 good = true;
  //                 effect.target_int.area.base = radius;
  //                 effect.target_int.area2.base = high;
  //               }
  //             }
  //           } else if (area_type === "Cone") {
  //             let cone_index = desc_pieces.findIndex(o => o === "cone");
  //             if (cone_index < 0) {
  //               cone_index = desc_pieces.findIndex(o => o.includes("cone"));
  //             }
  //             if (cone_index > 0) {
  //               let cone = 0;
  //               for (let j = 0; j < 5; ++j) {
  //                 if (desc_pieces[cone_index - j].includes("-")) {
  //                   const area_pieces = desc_pieces[cone_index - j].split("-");
  //                   cone = +area_pieces[0];
  //                 } else {
  //                   cone = +desc_pieces[cone_index - j];
  //                 }
  //                 if (!isNaN(cone)) {
  //                   break;
  //                 }
  //               }
  //               if (!isNaN(cone)) {
  //                 good = true;
  //                 effect.target_int.area.base = cone;
  //               }
  //             }
  //           } else if (area_type === "Cube") {
  //             let cube_index = desc_pieces.findIndex(o => o === "cube");
  //             if (cube_index < 0) {
  //               cube_index = desc_pieces.findIndex(o => o.includes("cube"));
  //             }
  //             if (cube_index > 0) {
  //               let cube = 0;
  //               if (desc_pieces[cube_index].includes("-")) {
  //                 const area_pieces = desc_pieces[cube_index].split("-");
  //                 cube = +area_pieces[0];
  //               } else {
  //                 cube = +desc_pieces[cube_index - 1];
  //                 if (isNaN(cube) && desc_pieces[cube_index - 1].includes("-")) {
  //                   const area_pieces = desc_pieces[cube_index - 1].split("-");
  //                   cube = +area_pieces[0];
  //                 }
  //                 if (isNaN(cube)) {
  //                   cube = +desc_pieces[cube_index - 2];
  //                 }
  //               }
  //               if (!isNaN(cube)) {
  //                 good = true;
  //                 effect.target_int.area.base = cube;
  //               } else {
  //                 // It may be be in a format like this: a Cube up to 100 feet on a side
  //                 cube_index = desc_pieces.findIndex(o => o === "side");
  //                 if (cube_index > 0) {
  //                   cube = 0;
  //                   for (let j = 0; j < 5; ++j) {
  //                     if (desc_pieces[cube_index - j].includes("-")) {
  //                       const area_pieces = desc_pieces[cube_index - j].split("-");
  //                       cube = +area_pieces[0];
  //                     } else {
  //                       cube = +desc_pieces[cube_index - j];
  //                     }
  //                     if (!isNaN(cube)) {
  //                       break;
  //                     }
  //                   }
  //                   if (!isNaN(cube)) {
  //                     good = true;
  //                     effect.target_int.area.base = cube;
  //                   }
  //                 }
  //               }
  //             }
  //           } else if (area_type === "Line") {
  //             let long_index = desc_pieces.findIndex(o => o === "long");
  //             if (long_index < 0) {
  //               long_index = desc_pieces.findIndex(o => o.includes("long"));
  //             }
  //             let wide_index = desc_pieces.findIndex(o => o === "wide");
  //             if (wide_index < 0) {
  //               wide_index = desc_pieces.findIndex(o => o.includes("wide"));
  //             }
  //             if (long_index > 0 && wide_index > 0) {
  //               let long = 0;
  //               let wide = 0;
  //               if (desc_pieces[long_index].includes("-")) {
  //                 const area_pieces = desc_pieces[long_index].split("-");
  //                 long = +area_pieces[0];
  //               } else {
  //                 long = +desc_pieces[long_index - 1];
  //                 if (isNaN(long) && desc_pieces[long_index - 1].includes("-")) {
  //                   const area_pieces = desc_pieces[long_index - 1].split("-");
  //                   long = +area_pieces[0];
  //                 }
  //                 if (isNaN(long)) {
  //                   long = +desc_pieces[long_index - 2];
  //                 }
  //               }
  //               if (desc_pieces[wide_index].includes("-")) {
  //                 const area_pieces = desc_pieces[wide_index].split("-");
  //                 wide = +area_pieces[0];
  //               } else {
  //                 wide = +desc_pieces[wide_index - 1];
  //                 if (isNaN(wide) && desc_pieces[wide_index - 1].includes("-")) {
  //                   const area_pieces = desc_pieces[wide_index - 1].split("-");
  //                   wide = +area_pieces[0];
  //                 }
  //                 if (isNaN(wide)) {
  //                   wide = +desc_pieces[wide_index - 2];
  //                 }
  //               }
  //               if (!isNaN(long) && !isNaN(wide)) {
  //                 good = true;
  //                 effect.target_int.area.base = long;
  //                 effect.target_int.area2.base = wide;
  //               }
  //             }
  //           } else if (area_type === "Square") {
  //             let square_index = desc_pieces.findIndex(o => o === "square");
  //             if (square_index < 0) {
  //               square_index = desc_pieces.findIndex(o => o.includes("square"));
  //             }
  //             if (square_index > 0) {
  //               let square = 0;
  //               if (desc_pieces[square_index].includes("-")) {
  //                 const area_pieces = desc_pieces[square_index].split("-");
  //                 square = +area_pieces[0];
  //               } else {
  //                 square = +desc_pieces[square_index - 1];
  //                 if (isNaN(square) && desc_pieces[square_index - 1].includes("-")) {
  //                   const area_pieces = desc_pieces[square_index - 1].split("-");
  //                   square = +area_pieces[0];
  //                 }
  //                 if (isNaN(square)) {
  //                   square = +desc_pieces[square_index - 2];
  //                 }
  //               }
  //               if (!isNaN(square)) {
  //                 good = true;
  //                 effect.target_int.area.base = square;
  //               } else {
  //                 // It may be be in a format like this: a Cube up to 100 feet on a side
  //                 square_index = desc_pieces.findIndex(o => o === "side");
  //                 if (square_index > 0) {
  //                   square = 0;
  //                   for (let j = 0; j < 5; ++j) {
  //                     if (desc_pieces[square_index - j].includes("-")) {
  //                       const area_pieces = desc_pieces[square_index - j].split("-");
  //                       square = +area_pieces[0];
  //                     } else {
  //                       square = +desc_pieces[square_index - j];
  //                     }
  //                     if (!isNaN(square)) {
  //                       break;
  //                     }
  //                   }
  //                   if (!isNaN(square)) {
  //                     good = true;
  //                     effect.target_int.area.base = square;
  //                   }
  //                 }
  //               }
  //             }
  //           } else if (area_type === "Wall") {
  //             // if (current_spell.name.includes("Wind Wall")) {
  //             //   debugger;
  //             // }
  //             let long_index = desc_pieces.findIndex(o => o === "long");
  //             if (long_index < 0) {
  //               long_index = desc_pieces.findIndex(o => o.includes("long"));
  //             }
  //             let high_index = desc_pieces.findIndex(o => o === "high");
  //             if (high_index < 0) {
  //               high_index = desc_pieces.findIndex(o => o.includes("high"));
  //             }
  //             let thick_index = desc_pieces.findIndex(o => o === "thick");
  //             if (thick_index < 0) {
  //               thick_index = desc_pieces.findIndex(o => o.includes("thick"));
  //             }
  //             if (long_index > 0 && high_index > 0 && thick_index > 0) {
  //               let long = 0;
  //               let high = 0;
  //               let thick = 0;
  //               if (desc_pieces[long_index].includes("-")) {
  //                 const area_pieces = desc_pieces[long_index].split("-");
  //                 long = +area_pieces[0];
  //               } else {
  //                 long = +desc_pieces[long_index - 1];
  //                 if (isNaN(long) && desc_pieces[long_index - 1].includes("-")) {
  //                   const area_pieces = desc_pieces[long_index - 1].split("-");
  //                   long = +area_pieces[0];
  //                 }
  //                 if (isNaN(long)) {
  //                   long = +desc_pieces[long_index - 2];
  //                 }
  //               }
  //               if (desc_pieces[high_index].includes("-")) {
  //                 const area_pieces = desc_pieces[high_index].split("-");
  //                 high = +area_pieces[0];
  //               } else {
  //                 high = +desc_pieces[high_index - 1];
  //                 if (isNaN(high) && desc_pieces[high_index - 1].includes("-")) {
  //                   const area_pieces = desc_pieces[high_index - 1].split("-");
  //                   high = +area_pieces[0];
  //                 }
  //                 if (isNaN(high)) {
  //                   high = +desc_pieces[high_index - 2];
  //                 }
  //               }
  //               if (desc_pieces[thick_index].includes("-")) {
  //                 const area_pieces = desc_pieces[thick_index].split("-");
  //                 thick = +area_pieces[0];
  //               } else {
  //                 thick = +desc_pieces[thick_index - 1];
  //                 if (isNaN(thick) && desc_pieces[thick_index - 1].includes("-")) {
  //                   const area_pieces = desc_pieces[thick_index - 1].split("-");
  //                   thick = +area_pieces[0];
  //                 }
  //                 if (isNaN(thick)) {
  //                   thick = +desc_pieces[thick_index - 2];
  //                 }
  //               }
  //               if (!isNaN(long) && !isNaN(high) && !isNaN(thick)) {
  //                 good = true;
  //                 effect.target_int.area.base = long;
  //                 effect.target_int.area2.base = high;
  //                 effect.target_int.area3.base = thick;
  //               }
  //             }
  //           }
  //           if (good) {
  //             effect.target_int.target_type = "Area";
  //             effect.target_int.area_type = area_type;
  //             break;
  //           } else {
  //             current_spell.parse_errors.push("Area format not matching.");
  //             console.error("Area format not matching.");
  //             console.error(current_spell.name);
  //             console.error(main_description);
  //           }
  //         }
  //       }
  //       for (const condition of conditions) {
  //         if (main_description.includes(condition.name)) {
  //           const using_effect = effect.type === "None" ? effect : new AbilityEffect();
  //           if (using_effect.type === "None") {
  //             if (condition.name === "Invisible") {
  //               using_effect.type = "Utility";
  //             } else {
  //               using_effect.type = "Control";
  //             }
  //           }
  //           using_effect.utility_detail = condition.name;
  //           if (using_effect.true_id !== effect.true_id) {
  //             current_spell.effects.push(using_effect);
  //           }
  //         }
  //       }
  //       if (effect.type === "None") {
  //         if (effect.attack_type !== "None") {
  //           // Complicated Control Effects, like Counterspell
  //           effect.type = "Control";
  //         } else {
  //           // Look for other types of effects
  //           if (main_description.includes("Hit Points")) {
  //             // Figure out how much. Formats are below:
  //             // regains Hit Points equal to 2d4 plus your spellcasting ability modifier.
  //             // restoring 70 Hit Points. 
  //             // regains all its Hit Points. 
  //             // regain 2d8 Hit Points. 
  //             // Hit Points increase by 5 
  //             // gain 2d4 + 4 Temporary Hit Points.
  //             // gains Temporary Hit Points equal to your spellcasting ability modifier
  //             // Hit Point maximum and current Hit Points increase by 5 
  //             if (main_description.includes("Temporary Hit Points")) {
  //               effect.type = "Temp HP";
  //               if (main_description.includes("equal to ")) {
  //                 let after = main_description.substring(main_description.indexOf("equal to") + 8).trim();
  //                 after = after.substring(0, after.indexOf("."));
  //                 const potence = new Potence();
  //                 potence.level = current_spell.level;
  //                 potence.rolls = common_util.parse_dice_roll_upgradable(after);
  //                 effect.potences.push(potence);
  //               } else if (main_description.includes("gain ")) {
  //                 let after = main_description.substring(main_description.indexOf("gain ") + 4).trim();
  //                 after = after.substring(0, after.indexOf("."));
  //                 const potence = new Potence();
  //                 potence.level = current_spell.level;
  //                 potence.rolls = common_util.parse_dice_roll_upgradable(after);
  //                 effect.potences.push(potence);
  //               } else if (main_description.includes("gains ")) {
  //                 let after = main_description.substring(main_description.indexOf("gains ") + 5).trim();
  //                 after = after.substring(0, after.indexOf("."));
  //                 const potence = new Potence();
  //                 potence.level = current_spell.level;
  //                 potence.rolls = common_util.parse_dice_roll_upgradable(after);
  //                 effect.potences.push(potence);
  //               }
  //             } else if (main_description.includes("Hit Point maximum") && main_description.includes("increase by ")) {
  //               effect.type = "Max HP";
  //               let after = main_description.substring(main_description.indexOf("increase by ") + 11).trim();
  //               after = after.substring(0, after.indexOf("."));
  //               const potence = new Potence();
  //               potence.level = current_spell.level;
  //               potence.rolls = common_util.parse_dice_roll_upgradable(after);
  //               effect.potences.push(potence);
  //             } else if (main_description.includes("regains all")) {
  //               effect.type = "Healing";
  //               const potence = new Potence();
  //               potence.level = current_spell.level;
  //               potence.rolls.flat.base = 1;
  //               effect.potences.push(potence);
  //             } else if (main_description.includes("regains Hit Points equal to")) {
  //               effect.type = "Healing";
  //               let after = main_description.substring(main_description.indexOf("regains Hit Points equal to") + 27).trim();
  //               after = after.substring(0, after.indexOf("."));
  //               const potence = new Potence();
  //               potence.level = current_spell.level;
  //               potence.rolls = common_util.parse_dice_roll_upgradable(after);
  //               effect.potences.push(potence);
  //             } else if (main_description.includes("regain ")) {
  //               effect.type = "Healing";
  //               let after = main_description.substring(main_description.indexOf("regain ") + 6).trim();
  //               after = after.substring(0, after.indexOf("."));
  //               const potence = new Potence();
  //               potence.level = current_spell.level;
  //               potence.rolls = common_util.parse_dice_roll_upgradable(after);
  //               effect.potences.push(potence);
  //             } else if (main_description.includes("restoring")) {
  //               effect.type = "Healing";
  //               let after = main_description.substring(main_description.indexOf("restoring") + 9).trim();
  //               after = after.substring(0, after.indexOf("."));
  //               const potence = new Potence();
  //               potence.level = current_spell.level;
  //               potence.rolls = common_util.parse_dice_roll_upgradable(after);
  //               effect.potences.push(potence);
  //             }
  //             if (effect.potences.length === 1) {
  //               const potence = effect.potences[0];
  //               if (upgrade_description.includes("Higher-Level Spell Slot")) {
  //                 if (upgrade_description.includes("increase by") || upgrade_description.includes("increases by")) {
  //                   let word = "";
  //                   if (upgrade_description.includes("increases by")) {
  //                     // The damage increases by 1d8 for each spell slot level above 4.
  //                     word = upgrade_description.substring(upgrade_description.indexOf("increases by ") + 13).trim();
  //                   } else {
  //                     // Each target’s Hit Points increase by 5 for each spell slot level above 2.
  //                     word = upgrade_description.substring(upgrade_description.indexOf("increase by ") + 12).trim();
  //                   }
  //                   word = word.substring(0, word.indexOf(" ")).trim();
  //                   const roll = common_util.parse_dice_roll(word);
  //                   if (potence.rolls.size.base === roll.size || (roll.count === 0 && potence.rolls.size.base === 0)) {
  //                     let last_p = potence;
  //                     for (let j = current_spell.level + 1; j < 10; ++j) {
  //                       const p = last_p.clone(true);
  //                       p.level = j;
  //                       if (roll.count === 0) {
  //                         p.rolls.flat.base += roll.flat;
  //                       } else {
  //                         p.rolls.count.base += roll.count;
  //                       }
  //                       effect.potences.push(p);
  //                       last_p = p;
  //                     }
  //                   }
  //                 }
  //               } else if (upgrade_description.includes("Cantrip Upgrade")) {
  //                 if (upgrade_description.includes("increases by")) {
  //                   // The damage increases by 1d6 when you reach levels 5 (2d6), 11 (3d6), and 17 (4d6).
  //                   let word = upgrade_description.substring(upgrade_description.indexOf("increases by ") + 13).trim();
  //                   word = word.substring(0, word.indexOf(" ")).trim();
  //                   const roll = common_util.parse_dice_roll(word);
  //                   if (potence.rolls.size.base === roll.size || (roll.count === 0 && potence.rolls.size.base === 0)) {
  //                     const p5 = potence.clone(true);
  //                     p5.level = 5;
  //                     if (roll.count === 0) {
  //                       p5.rolls.flat.base += roll.flat;
  //                     } else {
  //                       p5.rolls.count.base += roll.count;
  //                     }
  //                     effect.potences.push(p5);
  //                     const p11 = p5.clone(true);
  //                     p11.level = 11;
  //                     if (roll.count === 0) {
  //                       p11.rolls.flat.base += roll.flat;
  //                     } else {
  //                       p11.rolls.count.base += roll.count;
  //                     }
  //                     effect.potences.push(p11);
  //                     const p17 = p11.clone(true);
  //                     p17.level = 17;
  //                     if (roll.count === 0) {
  //                       p17.rolls.flat.base += roll.flat;
  //                     } else {
  //                       p17.rolls.count.base += roll.count;
  //                     }
  //                     effect.potences.push(p17);
  //                   }
  //                 }
  //               }
  //             }
  //             if (effect.type === "None") {
  //               if (main_description.includes("regains") || 
  //                 main_description.includes("restoring") || 
  //                 main_description.toLocaleLowerCase().includes("healing")) {
  //                 effect.type = "Healing";
  //               }
  //             }
  //           } else {
  //             console.log(current_spell);
  //           }
  //         }
  //       }
  //       new_spells.push(current_spell);
  //     }
  //   }

  //   while (i < elem.children.length) {
  //     const child = elem.children[i];
  //     ++i;
  //     if (child instanceof HTMLElement && (child.className.includes("separator") || child.className.includes("compendium-hr heading-anchor"))) {
  //       // Starting a new spell.
  //       addSpell();
  //       current_spell = new Spell();
  //     } else if (child instanceof HTMLElement) {
  //       if (child.tagName === "FIGURE") {
  //         // It's an image, ignore it
  //       } else if (current_spell.name.length === 0) {
  //         // It's going to be something like this: <h3 class="compendium-hr h4-override with-metadata heading-anchor" id="AcidSplash" data-content-chunk-id="5452cd63-a13d-43ca-8fe5-ee72e22cb362"><a href="#AcidSplash" data-content-chunk-id="060d46c0-8b64-49c0-9eaa-b1b96a88dbe4"></a><a class="tooltip-hover spell-tooltip" href="/spells/2618844-acid-splash" data-tooltip-href="//www.dndbeyond.com/spells/2618844-tooltip?disable-webm=1&amp;disable-webm=1">Acid Splash</a></h3>
  //         // We just need to get the text from it.
  //         current_spell.name = child.textContent ? child.textContent : "";
  //         current_spell.name = current_spell.name.replace("’", "'");
  //       } else if (current_spell.school.length === 0) {
  //         // It's going to be something like this: <p data-content-chunk-id="0faac465-6910-49ab-9755-e6c425a3ec37"><em>Evocation Cantrip (Sorcerer, Wizard)</em></p>
  //         const str = child.textContent ? child.textContent : "";
  //         const pieces = str.split("(");
  //         // pieces[0] === "Evocation Cantrip "
  //         // pieces[1] === "Sorcerer, Wizard)"
  //         if (pieces[0].includes("Cantrip")) {
  //           const sub_pieces = pieces[0].split(" ");
  //           // sub_pieces[0] === "Evocation" - School
  //           current_spell.school = isSchoolOfMagic(sub_pieces[0]) ? sub_pieces[0] : "";
  //           // sub_pieces[1] === "Cantrip" - Level
  //           current_spell.level = 0;
  //         } else {
  //           // If it's not a cantrip then pieces[0] is like this instead: Level 2 Evocation
  //           const sub_pieces = pieces[0].split(" ");
  //           current_spell.school = isSchoolOfMagic(sub_pieces[2]) ? sub_pieces[2] : "";
  //           current_spell.level = +sub_pieces[1] as SpellLevel;
  //         }
  //         if (pieces[1]) {
  //           const sl_strings = pieces[1].replace(")","").replace(",","").split(" ");
  //           for (const sl_string of sl_strings) {
  //             const spell_list = spell_lists.find(o => o.name === sl_string);
  //             if (spell_list) {
  //               current_spell.spell_list_ids.push(spell_list._id);
  //             }
  //           }
  //         } else {
  //           console.error("Parse Failure");
  //           console.error(str);
  //           console.error(child);
  //         }
  //       } else {
  //         if (current_spell.effects.length === 0) {
  //           // Next is Casting Time, Range, Components, Duration
  //           if (child instanceof HTMLDivElement) {
  //             let casting_time_string = "";
  //             let range_string = "";
  //             let components_string = "";
  //             let duration_string = "";
  //             for (let j = 0; j < child.children.length; ++j) {
  //               const grandchild = child.children[j] as HTMLElement;
  //               if (grandchild && grandchild.textContent) {
  //                 if (grandchild.textContent.includes("Casting Time:")) {
  //                   casting_time_string = grandchild.textContent.replace("Casting Time:","").trim();
  //                 } else if (grandchild.textContent.includes("Range:")) {
  //                   range_string = grandchild.textContent.replace("Range:","").replace("feet","").replace("foot","").replace("ft.","").replace("ft","").trim();
  //                 } else if (grandchild.textContent.includes("Components:")) {
  //                   components_string = grandchild.textContent.replace("Components:","").trim();
  //                 } else if (grandchild.textContent.includes("Duration:")) {
  //                   duration_string = grandchild.textContent.replace("Duration:","").replace("up to", "").replace(",","").trim().toLocaleLowerCase();
  //                 }
  //               }
  //             }
  //             if (casting_time_string.includes("Reaction")) {
  //               current_spell.casting_time = "RA";
  //             } else if (casting_time_string.includes("Bonus")) {
  //               current_spell.casting_time = "BA";
  //             } else if (casting_time_string.includes("Action")) {
  //               current_spell.casting_time = "A";
  //             } else if (casting_time_string.includes("1 minute")) {
  //               current_spell.casting_time = "Special";
  //               current_spell.special_casting_time = "1 Minute";
  //             } else if (casting_time_string.includes("1 hour")) {
  //               current_spell.casting_time = "Special";
  //               current_spell.special_casting_time = "1 Hour";
  //             } else if (casting_time_string.includes("10 minutes")) {
  //               current_spell.casting_time = "Special";
  //               current_spell.special_casting_time = "10 Minute";
  //             } else {
  //               current_spell.casting_time = "Special";
  //               current_spell.special_casting_time = casting_time_string;
  //             }
  //             if (casting_time_string.includes("Ritual")) {
  //               current_spell.ritual = true;
  //             }
  //             if (components_string.includes("V")) {
  //               current_spell.components.push("V");
  //             }
  //             if (components_string.includes("S")) {
  //               current_spell.components.push("S");
  //             }
  //             if (components_string.includes("M")) {
  //               current_spell.components.push("M");
  //               current_spell.material_component = components_string.substring(components_string.indexOf("(")).replace("(","").replace(")","");
  //             }
  //             if (duration_string.includes("concentration")) {
  //               current_spell.concentration = true;
  //               duration_string = duration_string.replace("concentration", "");
  //             }
  //             if (duration_string.includes("instantaneous")) {
  //               current_spell.duration = "Instantaneous";
  //             } else if (duration_string.includes("8 hour")) {
  //               current_spell.duration = "8 Hours";
  //             } else if (duration_string.includes("24 hour")) {
  //               current_spell.duration = "24 Hours";
  //             } else if (duration_string.includes("1 hour")) {
  //               current_spell.duration = "1 Hour";
  //             } else if (duration_string.includes("1 min")) {
  //               current_spell.duration = "1 Minute";
  //             } else if (duration_string.includes("1 rou")) {
  //               current_spell.duration = "1 Round";
  //             } else if (duration_string.includes("10 min")) {
  //               current_spell.duration = "10 Minutes";
  //             } else if (duration_string.includes("2 rou")) {
  //               current_spell.duration = "2 Rounds";
  //             } else if (duration_string.includes("dispel")) {
  //               current_spell.duration = "Until Dispelled";
  //             } else {
  //               current_spell.duration = "Special";
  //               current_spell.special_duration = common_util.capitalize_first(duration_string);
  //             }
  //             const effect = new AbilityEffect();
  //             if (range_string === "Touch") {
  //               effect.target_int.range.base = 0;
  //             } else if (range_string === "Self") {
  //               effect.target_int.target_type = "Self";
  //             } else {
  //               effect.target_int.range.base = +range_string;
  //             }
  //             current_spell.effects.push(effect);
  //           }
  //         } else if (child.textContent) {
  //           // The rest goes into Description
  //           current_spell.description += child.textContent + "\r\n\r\n";
  //         }
  //       }
  //     }
  //   }
  //   addSpell();
  //   setSpells(new_spells);
  // }
  
  const parse = () => {
    let elem = parseRef.current as HTMLElement;
    while (elem instanceof HTMLDivElement && elem.children.length < 2) {
      elem = elem.children[0] as HTMLElement;
    }
    
    const new_spells: Spell[] = [];
    let i = 0;
    
    // Find the first h3 (spell heading)
    while (i < elem.children.length) {
      const child = elem.children[i];
      ++i;
      if (child instanceof HTMLElement && child.tagName === "H3") {
        // Found first spell, back up one so we process it
        --i;
        break;
      }
    }
    
    let current_spell = new Spell();
    let parsing_stage: 'name' | 'metadata' | 'casting' | 'description' = 'name';
  
    const addSpell = () => {
      if (current_spell.name.length > 0) {
        const possible_variants = old_spells.filter(o => o.name === current_spell.name);
        let variant_group_ids: string[] = [];
        for (const pv of possible_variants) {
          variant_group_ids.push(pv.variant_group_id);
          current_spell.variant_ids = [...pv.variant_ids,...current_spell.variant_ids];
        }
        variant_group_ids = common_util.unique_array(variant_group_ids);
        current_spell.variant_ids = common_util.unique_array(current_spell.variant_ids);
        if (variant_group_ids.length === 1) {
          current_spell.variant_of_id = variant_group_ids[0];
          current_spell.variant_group = possible_variants;
        }
        
        if (api.working_on_sb) {
          const sb_id = api.working_on_sb._id;
          current_spell.source_books_old = [{ id: api.working_on_sb._id, type: api.working_on_sb.source_book_type, third_party: api.working_on_sb.third_party }];
          if (possible_variants.filter(o => o.source_book_ids.includes(sb_id)).length > 0) {
            current_spell.parse_errors.push("Variant on Book Already Exists.");
          }
        }
  
        current_spell.description = common_util.cleanSpaces(current_spell.description);
  
        let main_description = current_spell.description;
        let upgrade_description = "";
        
        if (current_spell.description.includes("Cantrip Upgrade.") && !current_spell.description.includes("<b>")) {
          upgrade_description = main_description.substring(main_description.indexOf("Cantrip Upgrade."));
          main_description = main_description.substring(0, main_description.indexOf("Cantrip Upgrade.") - 1);
          current_spell.description = current_spell.description.replace("Cantrip Upgrade.", "<b>Cantrip Upgrade.</b>");
        } else if (current_spell.description.includes("Using a Higher-Level Spell Slot.") && !current_spell.description.includes("<b>")) {
          upgrade_description = main_description.substring(main_description.indexOf("Using a Higher-Level Spell Slot."));
          main_description = main_description.substring(0, main_description.indexOf("Using a Higher-Level Spell Slot.") - 1);
          current_spell.description = current_spell.description.replace("Using a Higher-Level Spell Slot.", "<b>Using a Higher-Level Spell Slot.</b>");
        } 
  
        if (current_spell.effects.length === 0) {
          current_spell.effects.push(new AbilityEffect());
        }
        const effect = current_spell.effects[0];
        const desc_pieces = main_description.toLocaleLowerCase().split(" ");
        if (main_description.includes("damage")) {
          let good = false;
          let roll = new RollPlusUpgradable();
          let look_in = [...desc_pieces];
          while (look_in.length > 0) {
            const index = look_in.findIndex(str => str.includes("damage"));
            if (index < 0) {
              break;
            }
            const dt_string = common_util.capitalize_first(look_in[index - 1]);
            let potence_string = look_in[index - 2];
            if (!potence_string.includes("d") && !isNaN(+potence_string)) {
              if (look_in[index - 3] === "plus" || look_in[index - 3] === "+") {
                potence_string = look_in[index - 4] + " " + look_in[index - 3] + " " + potence_string;
              }
            }
            if (isDamageType(dt_string)) {
              if (!effect.damage_types.includes(dt_string as DamageType)) {
                effect.damage_types.push(dt_string as DamageType);
              }
              roll = common_util.parseDiceRollUpgradable(potence_string);
              if (roll.isBlank()) {
                look_in = look_in.slice(index + 1);
              } else {
                good = true;
                break;
              }
            } else if (!isDamageType(dt_string)) {
              if (dt_string.includes("d")) {
                roll = common_util.parseDiceRollUpgradable(dt_string);
                if (roll.isBlank()) {
                  look_in = look_in.slice(index + 1);
                } else {
                  good = true;
                  break;
                }
              } else {
                look_in = look_in.slice(index + 1);
              }
            } else {
              look_in = look_in.slice(index + 1);
            }
          }
          if (!good) {
            look_in = [...desc_pieces];
            while (look_in.length > 0) {
              const index = look_in.findIndex(str => str.includes("damage"));
              if (index < 0) {
                break;
              }
              if (look_in[index + 1] === "equal" && look_in[index + 2] === "to") {
                const dt_string = common_util.capitalize_first(look_in[index - 1]);
                if (isDamageType(dt_string)) {
                  if (!effect.damage_types.includes(dt_string)) {
                    effect.damage_types.push(dt_string);
                  }
                }
                let potence_string = look_in[index + 3];
                if (look_in[index + 4] === "plus" || look_in[index + 4] === "+") {
                  potence_string += " " + look_in[index + 4];
                  let j = index + 5;
                  while (j < look_in.length) {
                    potence_string += " " + look_in[j];
                    if (look_in[j].includes(".") || look_in[j].includes(",")) {
                      break;
                    }
                    ++j;
                  }
                }
                roll = common_util.parseDiceRollUpgradable(potence_string);
                if (roll.isBlank()) {
                  look_in = look_in.slice(index + 1);
                } else {
                  good = true;
                  break;
                }
              } else {
                look_in = look_in.slice(index + 1);
              }
            }
          }
          if (good) {
            effect.type = "Damage";
            const potence = new Potence();
            if (current_spell.level > 0) {
              potence.level = current_spell.level;
            } else {
              effect.potence_type = "Character";
              potence.level = 1;
            }
            potence.rolls = roll;
            effect.potences.push(potence);
            if (upgrade_description.includes("Higher-Level Spell Slot")) {
              if (upgrade_description.includes("increases by")) {
                let word = upgrade_description.substring(upgrade_description.indexOf("increases by ") + 13).trim();
                word = word.substring(0, word.indexOf(" ")).trim();
                const roll = common_util.parseDiceRoll(word);
                if (potence.rolls.size.base === roll.size || (roll.count === 0 && potence.rolls.size.base === 0)) {
                  let last_p = potence;
                  for (let j = current_spell.level + 1; j < 10; ++j) {
                    const p = last_p.clone(true);
                    p.level = j;
                    if (roll.count === 0) {
                      p.rolls.flat.base += roll.flat;
                    } else {
                      p.rolls.count.base += roll.count;
                    }
                    effect.potences.push(p);
                    last_p = p;
                  }
                }
              }
            } else if (upgrade_description.includes("Cantrip Upgrade")) {
              if (upgrade_description.includes("increases by")) {
                let word = upgrade_description.substring(upgrade_description.indexOf("increases by ") + 13).trim();
                word = word.substring(0, word.indexOf(" ")).trim();
                const roll = common_util.parseDiceRoll(word);
                if (potence.rolls.size.base === roll.size || (roll.count === 0 && potence.rolls.size.base === 0)) {
                  const p5 = potence.clone(true);
                  p5.level = 5;
                  if (roll.count === 0) {
                    p5.rolls.flat.base += roll.flat;
                  } else {
                    p5.rolls.count.base += roll.count;
                  }
                  effect.potences.push(p5);
                  const p11 = p5.clone(true);
                  p11.level = 11;
                  if (roll.count === 0) {
                    p11.rolls.flat.base += roll.flat;
                  } else {
                    p11.rolls.count.base += roll.count;
                  }
                  effect.potences.push(p11);
                  const p17 = p11.clone(true);
                  p17.level = 17;
                  if (roll.count === 0) {
                    p17.rolls.flat.base += roll.flat;
                  } else {
                    p17.rolls.count.base += roll.count;
                  }
                  effect.potences.push(p17);
                }
              }
            }
            if (effect.damage_types.length === 0) {
              for (const dt of DAMAGE_TYPES) {
                if (main_description.includes(dt)) {
                  effect.damage_types.push(dt as DamageType);
                }
              }
            }
            if (effect.damage_types.length === 0) {
              current_spell.parse_errors.push("Unable to find Damage Types.");
            }
          } else {
            current_spell.parse_errors.push("Damage string format not matching.");
            console.error("Damage string format not matching.");
            console.error(main_description);
          }
        }
        if (effect.attack_type === "None") {
          if (main_description.includes("melee spell attack")) {
            effect.attack_type = "Melee Spell";
          } else if (main_description.includes("ranged spell attack")) {
            effect.attack_type = "Ranged Spell";
          } else if (main_description.includes("melee attack")) {
            effect.attack_type = "Melee";
          } else if (main_description.includes("ranged attack")) {
            effect.attack_type = "Ranged";
          } else {
            if (desc_pieces.includes("saving")) {
              const index = desc_pieces.findIndex(o => o === "saving");
              const prev = desc_pieces[index - 1];
              switch (prev) {
                case "strength": 
                  effect.attack_type = "Save";
                  effect.saving_throw_ability_score = "STR"; 
                break;
                case "dexterity": 
                  effect.attack_type = "Save";
                  effect.saving_throw_ability_score = "DEX"; 
                break;
                case "constitution": 
                  effect.attack_type = "Save";
                  effect.saving_throw_ability_score = "CON"; 
                break;
                case "intelligence": 
                  effect.attack_type = "Save";
                  effect.saving_throw_ability_score = "INT"; 
                break;
                case "wisdom": 
                  effect.attack_type = "Save";
                  effect.saving_throw_ability_score = "WIS"; 
                break;
                case "charisma": 
                  effect.attack_type = "Save";
                  effect.saving_throw_ability_score = "CHA"; 
                break;
              }
            } else if (desc_pieces.includes("save")) {
              const index = desc_pieces.findIndex(o => o === "save");
              const prev = desc_pieces[index - 1];
              switch (prev) {
                case "strength": 
                  effect.attack_type = "Save";
                  effect.saving_throw_ability_score = "STR"; 
                break;
                case "dexterity": 
                  effect.attack_type = "Save";
                  effect.saving_throw_ability_score = "DEX"; 
                break;
                case "constitution": 
                  effect.attack_type = "Save";
                  effect.saving_throw_ability_score = "CON"; 
                break;
                case "intelligence": 
                  effect.attack_type = "Save";
                  effect.saving_throw_ability_score = "INT"; 
                break;
                case "wisdom": 
                  effect.attack_type = "Save";
                  effect.saving_throw_ability_score = "WIS"; 
                break;
                case "charisma": 
                  effect.attack_type = "Save";
                  effect.saving_throw_ability_score = "CHA"; 
                break;
              }
            }
          }
        }
        for (const area_type of AREA_TYPES as AreaType[]) {
          if (desc_pieces.includes(area_type.toLocaleLowerCase())) {
            let good = false;
            if (area_type === "Circle" || 
              area_type === "Sphere") {
              let radius_index = desc_pieces.findIndex(o => o === "radius");
              if (radius_index < 0) {
                radius_index = desc_pieces.findIndex(o => o.includes("radius"));
              }
              if (radius_index > 0) {
                let radius = 0;
                if (desc_pieces[radius_index].includes("-")) {
                  const area_pieces = desc_pieces[radius_index].split("-");
                  radius = +area_pieces[0];
                } else {
                  radius = +desc_pieces[radius_index - 1];
                  if (isNaN(radius) && desc_pieces[radius_index - 1].includes("-")) {
                    const area_pieces = desc_pieces[radius_index - 1].split("-");
                    radius = +area_pieces[0];
                  }
                  if (isNaN(radius)) {
                    radius = +desc_pieces[radius_index - 2];
                  }
                }
                if (!isNaN(radius)) {
                  good = true;
                  effect.target_int.area.base = radius;
                }
              } else {
                let diameter_index = desc_pieces.findIndex(o => o === "diameter");
                if (diameter_index < 0) {
                  diameter_index = desc_pieces.findIndex(o => o.includes("diameter"));
                }
                if (diameter_index > 0) {
                  let diameter = 0;
                  if (desc_pieces[diameter_index].includes("-")) {
                    const area_pieces = desc_pieces[diameter_index].split("-");
                    diameter = +area_pieces[0];
                  } else {
                    diameter = +desc_pieces[diameter_index - 1];
                    if (isNaN(diameter) && desc_pieces[diameter_index - 1].includes("-")) {
                      const area_pieces = desc_pieces[diameter_index - 1].split("-");
                      diameter = +area_pieces[0];
                    }
                    if (isNaN(diameter)) {
                      diameter = +desc_pieces[diameter_index - 2];
                    }
                  }
                  if (!isNaN(diameter)) {
                    good = true;
                    effect.target_int.area.base = diameter / 2;
                  }
                }
              }
            } else if (area_type === "Cylinder") {
              let radius_index = desc_pieces.findIndex(o => o === "radius");
              if (radius_index < 0) {
                radius_index = desc_pieces.findIndex(o => o.includes("radius"));
              }
              let high_index = desc_pieces.findIndex(o => o === "high");
              if (high_index < 0) {
                high_index = desc_pieces.findIndex(o => o.includes("high"));
              }
              if (high_index < 0) {
                high_index = desc_pieces.findIndex(o => o === "tall");
                if (high_index < 0) {
                  high_index = desc_pieces.findIndex(o => o.includes("tall"));
                }
              }
              if (radius_index > 0 && high_index > 0) {
                let radius = 0;
                let high = 0;
                if (desc_pieces[radius_index].includes("-")) {
                  const area_pieces = desc_pieces[radius_index].split("-");
                  radius = +area_pieces[0];
                } else {
                  radius = +desc_pieces[radius_index - 1];
                  if (isNaN(radius) && desc_pieces[radius_index - 1].includes("-")) {
                    const area_pieces = desc_pieces[radius_index - 1].split("-");
                    radius = +area_pieces[0];
                  }
                  if (isNaN(radius)) {
                    radius = +desc_pieces[radius_index - 2];
                  }
                }
                if (desc_pieces[high_index].includes("-")) {
                  const area_pieces = desc_pieces[high_index].split("-");
                  high = +area_pieces[0];
                } else {
                  high = +desc_pieces[high_index - 1];
                  if (isNaN(high) && desc_pieces[high_index - 1].includes("-")) {
                    const area_pieces = desc_pieces[high_index - 1].split("-");
                    high = +area_pieces[0];
                  }
                  if (isNaN(high)) {
                    high = +desc_pieces[high_index - 2];
                  }
                }
                if (!isNaN(radius) && !isNaN(high)) {
                  good = true;
                  effect.target_int.area.base = radius;
                  effect.target_int.area2.base = high;
                }
              }
            } else if (area_type === "Cone") {
              let cone_index = desc_pieces.findIndex(o => o === "cone");
              if (cone_index < 0) {
                cone_index = desc_pieces.findIndex(o => o.includes("cone"));
              }
              if (cone_index > 0) {
                let cone = 0;
                for (let j = 0; j < 5; ++j) {
                  if (desc_pieces[cone_index - j].includes("-")) {
                    const area_pieces = desc_pieces[cone_index - j].split("-");
                    cone = +area_pieces[0];
                  } else {
                    cone = +desc_pieces[cone_index - j];
                  }
                  if (!isNaN(cone)) {
                    break;
                  }
                }
                if (!isNaN(cone)) {
                  good = true;
                  effect.target_int.area.base = cone;
                }
              }
            } else if (area_type === "Cube") {
              let cube_index = desc_pieces.findIndex(o => o === "cube");
              if (cube_index < 0) {
                cube_index = desc_pieces.findIndex(o => o.includes("cube"));
              }
              if (cube_index > 0) {
                let cube = 0;
                if (desc_pieces[cube_index].includes("-")) {
                  const area_pieces = desc_pieces[cube_index].split("-");
                  cube = +area_pieces[0];
                } else {
                  cube = +desc_pieces[cube_index - 1];
                  if (isNaN(cube) && desc_pieces[cube_index - 1].includes("-")) {
                    const area_pieces = desc_pieces[cube_index - 1].split("-");
                    cube = +area_pieces[0];
                  }
                  if (isNaN(cube)) {
                    cube = +desc_pieces[cube_index - 2];
                  }
                }
                if (!isNaN(cube)) {
                  good = true;
                  effect.target_int.area.base = cube;
                } else {
                  cube_index = desc_pieces.findIndex(o => o === "side");
                  if (cube_index > 0) {
                    cube = 0;
                    for (let j = 0; j < 5; ++j) {
                      if (desc_pieces[cube_index - j].includes("-")) {
                        const area_pieces = desc_pieces[cube_index - j].split("-");
                        cube = +area_pieces[0];
                      } else {
                        cube = +desc_pieces[cube_index - j];
                      }
                      if (!isNaN(cube)) {
                        break;
                      }
                    }
                    if (!isNaN(cube)) {
                      good = true;
                      effect.target_int.area.base = cube;
                    }
                  }
                }
              }
            } else if (area_type === "Line") {
              let long_index = desc_pieces.findIndex(o => o === "long");
              if (long_index < 0) {
                long_index = desc_pieces.findIndex(o => o.includes("long"));
              }
              let wide_index = desc_pieces.findIndex(o => o === "wide");
              if (wide_index < 0) {
                wide_index = desc_pieces.findIndex(o => o.includes("wide"));
              }
              if (long_index > 0 && wide_index > 0) {
                let long = 0;
                let wide = 0;
                if (desc_pieces[long_index].includes("-")) {
                  const area_pieces = desc_pieces[long_index].split("-");
                  long = +area_pieces[0];
                } else {
                  long = +desc_pieces[long_index - 1];
                  if (isNaN(long) && desc_pieces[long_index - 1].includes("-")) {
                    const area_pieces = desc_pieces[long_index - 1].split("-");
                    long = +area_pieces[0];
                  }
                  if (isNaN(long)) {
                    long = +desc_pieces[long_index - 2];
                  }
                }
                if (desc_pieces[wide_index].includes("-")) {
                  const area_pieces = desc_pieces[wide_index].split("-");
                  wide = +area_pieces[0];
                } else {
                  wide = +desc_pieces[wide_index - 1];
                  if (isNaN(wide) && desc_pieces[wide_index - 1].includes("-")) {
                    const area_pieces = desc_pieces[wide_index - 1].split("-");
                    wide = +area_pieces[0];
                  }
                  if (isNaN(wide)) {
                    wide = +desc_pieces[wide_index - 2];
                  }
                }
                if (!isNaN(long) && !isNaN(wide)) {
                  good = true;
                  effect.target_int.area.base = long;
                  effect.target_int.area2.base = wide;
                }
              }
            } else if (area_type === "Square") {
              let square_index = desc_pieces.findIndex(o => o === "square");
              if (square_index < 0) {
                square_index = desc_pieces.findIndex(o => o.includes("square"));
              }
              if (square_index > 0) {
                let square = 0;
                if (desc_pieces[square_index].includes("-")) {
                  const area_pieces = desc_pieces[square_index].split("-");
                  square = +area_pieces[0];
                } else {
                  square = +desc_pieces[square_index - 1];
                  if (isNaN(square) && desc_pieces[square_index - 1].includes("-")) {
                    const area_pieces = desc_pieces[square_index - 1].split("-");
                    square = +area_pieces[0];
                  }
                  if (isNaN(square)) {
                    square = +desc_pieces[square_index - 2];
                  }
                }
                if (!isNaN(square)) {
                  good = true;
                  effect.target_int.area.base = square;
                } else {
                  square_index = desc_pieces.findIndex(o => o === "side");
                  if (square_index > 0) {
                    square = 0;
                    for (let j = 0; j < 5; ++j) {
                      if (desc_pieces[square_index - j].includes("-")) {
                        const area_pieces = desc_pieces[square_index - j].split("-");
                        square = +area_pieces[0];
                      } else {
                        square = +desc_pieces[square_index - j];
                      }
                      if (!isNaN(square)) {
                        break;
                      }
                    }
                    if (!isNaN(square)) {
                      good = true;
                      effect.target_int.area.base = square;
                    }
                  }
                }
              }
            } else if (area_type === "Wall") {
              let long_index = desc_pieces.findIndex(o => o === "long");
              if (long_index < 0) {
                long_index = desc_pieces.findIndex(o => o.includes("long"));
              }
              let high_index = desc_pieces.findIndex(o => o === "high");
              if (high_index < 0) {
                high_index = desc_pieces.findIndex(o => o.includes("high"));
              }
              let thick_index = desc_pieces.findIndex(o => o === "thick");
              if (thick_index < 0) {
                thick_index = desc_pieces.findIndex(o => o.includes("thick"));
              }
              if (long_index > 0 && high_index > 0 && thick_index > 0) {
                let long = 0;
                let high = 0;
                let thick = 0;
                if (desc_pieces[long_index].includes("-")) {
                  const area_pieces = desc_pieces[long_index].split("-");
                  long = +area_pieces[0];
                } else {
                  long = +desc_pieces[long_index - 1];
                  if (isNaN(long) && desc_pieces[long_index - 1].includes("-")) {
                    const area_pieces = desc_pieces[long_index - 1].split("-");
                    long = +area_pieces[0];
                  }
                  if (isNaN(long)) {
                    long = +desc_pieces[long_index - 2];
                  }
                }
                if (desc_pieces[high_index].includes("-")) {
                  const area_pieces = desc_pieces[high_index].split("-");
                  high = +area_pieces[0];
                } else {
                  high = +desc_pieces[high_index - 1];
                  if (isNaN(high) && desc_pieces[high_index - 1].includes("-")) {
                    const area_pieces = desc_pieces[high_index - 1].split("-");
                    high = +area_pieces[0];
                  }
                  if (isNaN(high)) {
                    high = +desc_pieces[high_index - 2];
                  }
                }
                if (desc_pieces[thick_index].includes("-")) {
                  const area_pieces = desc_pieces[thick_index].split("-");
                  thick = +area_pieces[0];
                } else {
                  thick = +desc_pieces[thick_index - 1];
                  if (isNaN(thick) && desc_pieces[thick_index - 1].includes("-")) {
                    const area_pieces = desc_pieces[thick_index - 1].split("-");
                    thick = +area_pieces[0];
                  }
                  if (isNaN(thick)) {
                    thick = +desc_pieces[thick_index - 2];
                  }
                }
                if (!isNaN(long) && !isNaN(high) && !isNaN(thick)) {
                  good = true;
                  effect.target_int.area.base = long;
                  effect.target_int.area2.base = high;
                  effect.target_int.area3.base = thick;
                }
              }
            }
            if (good) {
              effect.target_int.target_type = "Area";
              effect.target_int.area_type = area_type;
              break;
            } else {
              current_spell.parse_errors.push("Area format not matching.");
              console.error("Area format not matching.");
              console.error(current_spell.name);
              console.error(main_description);
            }
          }
        }
        for (const condition of conditions) {
          if (main_description.includes(condition.name)) {
            const using_effect = effect.type === "None" ? effect : new AbilityEffect();
            if (using_effect.type === "None") {
              if (condition.name === "Invisible") {
                using_effect.type = "Utility";
              } else {
                using_effect.type = "Control";
              }
            }
            using_effect.utility_detail = condition.name;
            if (using_effect.true_id !== effect.true_id) {
              current_spell.effects.push(using_effect);
            }
          }
        }
        if (effect.type === "None") {
          if (effect.attack_type !== "None") {
            effect.type = "Control";
          } else {
            if (main_description.includes("Hit Points")) {
              if (main_description.includes("Temporary Hit Points")) {
                effect.type = "Temp HP";
                if (main_description.includes("equal to ")) {
                  let after = main_description.substring(main_description.indexOf("equal to") + 8).trim();
                  after = after.substring(0, after.indexOf("."));
                  const potence = new Potence();
                  potence.level = current_spell.level;
                  potence.rolls = common_util.parseDiceRollUpgradable(after);
                  effect.potences.push(potence);
                } else if (main_description.includes("gain ")) {
                  let after = main_description.substring(main_description.indexOf("gain ") + 4).trim();
                  after = after.substring(0, after.indexOf("."));
                  const potence = new Potence();
                  potence.level = current_spell.level;
                  potence.rolls = common_util.parseDiceRollUpgradable(after);
                  effect.potences.push(potence);
                } else if (main_description.includes("gains ")) {
                  let after = main_description.substring(main_description.indexOf("gains ") + 5).trim();
                  after = after.substring(0, after.indexOf("."));
                  const potence = new Potence();
                  potence.level = current_spell.level;
                  potence.rolls = common_util.parseDiceRollUpgradable(after);
                  effect.potences.push(potence);
                }
              } else if (main_description.includes("Hit Point maximum") && main_description.includes("increase by ")) {
                effect.type = "Max HP";
                let after = main_description.substring(main_description.indexOf("increase by ") + 11).trim();
                after = after.substring(0, after.indexOf("."));
                const potence = new Potence();
                potence.level = current_spell.level;
                potence.rolls = common_util.parseDiceRollUpgradable(after);
                effect.potences.push(potence);
              } else if (main_description.includes("regains all")) {
                effect.type = "Healing";
                const potence = new Potence();
                potence.level = current_spell.level;
                potence.rolls.flat.base = 1;
                effect.potences.push(potence);
              } else if (main_description.includes("regains Hit Points equal to")) {
                effect.type = "Healing";
                let after = main_description.substring(main_description.indexOf("regains Hit Points equal to") + 27).trim();
                after = after.substring(0, after.indexOf("."));
                const potence = new Potence();
                potence.level = current_spell.level;
                potence.rolls = common_util.parseDiceRollUpgradable(after);
                effect.potences.push(potence);
              } else if (main_description.includes("regain ")) {
                effect.type = "Healing";
                let after = main_description.substring(main_description.indexOf("regain ") + 6).trim();
                after = after.substring(0, after.indexOf("."));
                const potence = new Potence();
                potence.level = current_spell.level;
                potence.rolls = common_util.parseDiceRollUpgradable(after);
                effect.potences.push(potence);
              } else if (main_description.includes("restoring")) {
                effect.type = "Healing";
                let after = main_description.substring(main_description.indexOf("restoring") + 9).trim();
                after = after.substring(0, after.indexOf("."));
                const potence = new Potence();
                potence.level = current_spell.level;
                potence.rolls = common_util.parseDiceRollUpgradable(after);
                effect.potences.push(potence);
              }
              if (effect.potences.length === 1) {
                const potence = effect.potences[0];
                if (upgrade_description.includes("Higher-Level Spell Slot")) {
                  if (upgrade_description.includes("increase by") || upgrade_description.includes("increases by")) {
                    let word = "";
                    if (upgrade_description.includes("increases by")) {
                      word = upgrade_description.substring(upgrade_description.indexOf("increases by ") + 13).trim();
                    } else {
                      word = upgrade_description.substring(upgrade_description.indexOf("increase by ") + 12).trim();
                    }
                    word = word.substring(0, word.indexOf(" ")).trim();
                    const roll = common_util.parseDiceRoll(word);
                    if (potence.rolls.size.base === roll.size || (roll.count === 0 && potence.rolls.size.base === 0)) {
                      let last_p = potence;
                      for (let j = current_spell.level + 1; j < 10; ++j) {
                        const p = last_p.clone(true);
                        p.level = j;
                        if (roll.count === 0) {
                          p.rolls.flat.base += roll.flat;
                        } else {
                          p.rolls.count.base += roll.count;
                        }
                        effect.potences.push(p);
                        last_p = p;
                      }
                    }
                  }
                } else if (upgrade_description.includes("Cantrip Upgrade")) {
                  if (upgrade_description.includes("increases by")) {
                    let word = upgrade_description.substring(upgrade_description.indexOf("increases by ") + 13).trim();
                    word = word.substring(0, word.indexOf(" ")).trim();
                    const roll = common_util.parseDiceRoll(word);
                    if (potence.rolls.size.base === roll.size || (roll.count === 0 && potence.rolls.size.base === 0)) {
                      const p5 = potence.clone(true);
                      p5.level = 5;
                      if (roll.count === 0) {
                        p5.rolls.flat.base += roll.flat;
                      } else {
                        p5.rolls.count.base += roll.count;
                      }
                      effect.potences.push(p5);
                      const p11 = p5.clone(true);
                      p11.level = 11;
                      if (roll.count === 0) {
                        p11.rolls.flat.base += roll.flat;
                      } else {
                        p11.rolls.count.base += roll.count;
                      }
                      effect.potences.push(p11);
                      const p17 = p11.clone(true);
                      p17.level = 17;
                      if (roll.count === 0) {
                        p17.rolls.flat.base += roll.flat;
                      } else {
                        p17.rolls.count.base += roll.count;
                      }
                      effect.potences.push(p17);
                    }
                  }
                }
              }
              if (effect.type === "None") {
                if (main_description.includes("regains") || 
                  main_description.includes("restoring") || 
                  main_description.toLocaleLowerCase().includes("healing")) {
                  effect.type = "Healing";
                }
              }
            } else {
              console.log(current_spell);
            }
          }
        }
        new_spells.push(current_spell);
      }
    }
  
    while (i < elem.children.length) {
      const child = elem.children[i];
      ++i;
      
      if (child instanceof HTMLElement) {
        // Check if this is a new spell (starts with H3)
        if (child.tagName === "H3") {
          // Save the previous spell and start a new one
          addSpell();
          current_spell = new Spell();
          parsing_stage = 'name';
          
          // Extract spell name
          current_spell.name = child.textContent ? child.textContent.trim() : "";
          current_spell.name = current_spell.name.replace("'", "'");
          parsing_stage = 'metadata';
        } else if (child.tagName === "FIGURE") {
          // Skip images
          continue;
        } else if (parsing_stage === 'metadata' && child.tagName === "P") {
          // Parse school, level, and spell lists
          const str = child.textContent ? child.textContent : "";
          const pieces = str.split("(");
          
          if (pieces[0].includes("Cantrip")) {
            const sub_pieces = pieces[0].split(" ");
            current_spell.school = isSchoolOfMagic(sub_pieces[0]) ? sub_pieces[0] : "";
            current_spell.level = 0;
          } else {
            const sub_pieces = pieces[0].split(" ");
            current_spell.school = isSchoolOfMagic(sub_pieces[2]) ? sub_pieces[2] : "";
            current_spell.level = +sub_pieces[1] as SpellLevel;
          }
          
          if (pieces[1]) {
            const sl_strings = pieces[1].replace(")","").replace(/,/g,"").split(" ");
            for (const sl_string of sl_strings) {
              const spell_list = spell_lists.find(o => o.name === sl_string);
              if (spell_list) {
                current_spell.spell_list_ids.push(spell_list._id);
              }
            }
          }
          parsing_stage = 'casting';
        } else if (parsing_stage === 'casting' && child.className.includes("condensed-group")) {
          // Parse casting time, range, components, duration
          let casting_time_string = "";
          let range_string = "";
          let components_string = "";
          let duration_string = "";
          
          for (let j = 0; j < child.children.length; ++j) {
            const grandchild = child.children[j] as HTMLElement;
            if (grandchild && grandchild.textContent) {
              if (grandchild.textContent.includes("Casting Time:")) {
                casting_time_string = grandchild.textContent.replace("Casting Time:","").trim();
              } else if (grandchild.textContent.includes("Range:")) {
                range_string = grandchild.textContent.replace("Range:","").replace("feet","").replace("foot","").replace("ft.","").replace("ft","").trim();
              } else if (grandchild.textContent.includes("Components:")) {
                components_string = grandchild.textContent.replace("Components:","").trim();
              } else if (grandchild.textContent.includes("Duration:")) {
                duration_string = grandchild.textContent.replace("Duration:","").replace("up to", "").replace(",","").trim().toLocaleLowerCase();
              }
            }
          }
          
          // Parse casting time
          if (casting_time_string.includes("Reaction")) {
            current_spell.casting_time = "RA";
          } else if (casting_time_string.includes("Bonus")) {
            current_spell.casting_time = "BA";
          } else if (casting_time_string.includes("Action")) {
            current_spell.casting_time = "A";
          } else if (casting_time_string.includes("1 minute")) {
            current_spell.casting_time = "Special";
            current_spell.special_casting_time = "1 Minute";
          } else if (casting_time_string.includes("1 hour")) {
            current_spell.casting_time = "Special";
            current_spell.special_casting_time = "1 Hour";
          } else if (casting_time_string.includes("10 minutes")) {
            current_spell.casting_time = "Special";
            current_spell.special_casting_time = "10 Minute";
          } else {
            current_spell.casting_time = "Special";
            current_spell.special_casting_time = casting_time_string;
          }
          
          if (casting_time_string.includes("Ritual")) {
            current_spell.ritual = true;
          }
          
          // Parse components
          if (components_string.includes("V")) {
            current_spell.components.push("V");
          }
          if (components_string.includes("S")) {
            current_spell.components.push("S");
          }
          if (components_string.includes("M")) {
            current_spell.components.push("M");
            const material_start = components_string.indexOf("(");
            if (material_start >= 0) {
              current_spell.material_component = components_string.substring(material_start).replace("(","").replace(")","");
            }
          }
          
          // Parse duration
          if (duration_string.includes("concentration")) {
            current_spell.concentration = true;
            duration_string = duration_string.replace("concentration", "").trim();
          }
          if (duration_string.includes("instantaneous")) {
            current_spell.duration = "Instantaneous";
          } else if (duration_string.includes("8 hour")) {
            current_spell.duration = "8 Hours";
          } else if (duration_string.includes("24 hour")) {
            current_spell.duration = "24 Hours";
          } else if (duration_string.includes("1 hour")) {
            current_spell.duration = "1 Hour";
          } else if (duration_string.includes("1 min")) {
            current_spell.duration = "1 Minute";
          } else if (duration_string.includes("1 rou")) {
            current_spell.duration = "1 Round";
          } else if (duration_string.includes("10 min")) {
            current_spell.duration = "10 Minutes";
          } else if (duration_string.includes("2 rou")) {
            current_spell.duration = "2 Rounds";
          } else if (duration_string.includes("dispel")) {
            current_spell.duration = "Until Dispelled";
          } else {
            current_spell.duration = "Special";
            current_spell.special_duration = common_util.capitalize_first(duration_string);
          }
          
          // Create initial effect with range
          const effect = new AbilityEffect();
          if (range_string === "Touch") {
            effect.target_int.range.base = 0;
          } else if (range_string === "Self") {
            effect.target_int.target_type = "Self";
          } else {
            const range_num = parseInt(range_string);
            if (!isNaN(range_num)) {
              effect.target_int.range.base = range_num;
            }
          }
          current_spell.effects.push(effect);
          parsing_stage = 'description';
        } else if (parsing_stage === 'description' && child.tagName === "P") {
          // Add to description
          if (child.textContent) {
            current_spell.description += child.textContent + "\r\n\r\n";
          }
        }
      }
    }
    
    // Add the last spell
    addSpell();
    setSpells(new_spells);
  };

  const renderSpells = () => {
    return (
      <Grid size={12}>
        <Grid container spacing={0} direction="row">
          <Grid
            className="header centered"
            size={12}>Spells Ready to Add</Grid>
          <Grid size={3}>
            <CheckBox 
              name="Make Dominant"
              value={make_dominant}
              onChange={setMakeDominant}
            />
          </Grid>
          <Grid size={3}>
            <Button
              variant="contained"
              color="primary"
              disabled={ processing }
              onClick={() => { setSpells(spells.filter(o => !o.parse_errors.includes("Variant on Book Already Exists."))); }}>
              Delete All Already in Source
            </Button>
          </Grid>
          <Grid size={3}>
            <Button
              variant="contained"
              color="primary"
              disabled={ processing }
              onClick={() => {
                setProcessing(true);
                submit();
              }}>
              Save All
            </Button>
          </Grid>
          <Grid size={3}>
            <Button
              variant="contained"
              color="primary"
              disabled={ processing }
              onClick={() => { setSpells([]); }}>
              Cancel
            </Button>
          </Grid>
          { spells.map(spell => {
            return (
              <Grid
                key={spell.name}
                className="padded"
                size={12}>
                <Grid container spacing={0} direction="row"className={cx(classes.root)}>
                  <Grid
                    onClick={() => { setExpandedSpell(expanded_spell === spell.name ? "" : spell.name); }}
                    size={4}>
                    <ViewSpell
                      spell={spell}
                    />
                  </Grid>
                  <Grid size={4}>
                    <DisplayObjects type="spell" ids={spell.variant_ids} display_field="true_name" />
                  </Grid>
                  <Grid size={4}>
                    <DeleteButton
                      onClick={() => {
                        if (expanded_spell === spell.name) {
                          setExpandedSpell("");
                        }
                        setSpells(spells.filter(o => o.name !== spell.name));
                      }}
                    />
                  </Grid>
                  { spell.parse_errors.map((error, key) => {
                    return (
                      <Grid
                        key={key}
                        className="small_label red"
                        size={12}>
                        { error }
                      </Grid>
                    );
                  })}
                  { expanded_spell === spell.name &&
                    <>
                      <Grid size={12}>
                        <SpellDetails spell={spell} />
                      </Grid>
                      <Grid size={12}>
                        <SpellEffects
                          spell={spell}
                          disabled={false}
                          onChange={() => {
                            setPing(!ping);
                          }}
                        />
                      </Grid>
                    </>
                  }
                </Grid>
              </Grid>
            );
          })}
        </Grid>
      </Grid>
    );
  }

  const renderParser = () => {
    return (
      <>
        <Grid
          size={{
            xs: 9
          }}>
          <StringBox 
            name="Parse String"
            value={parse_string}
            onBlur={setParseString}
          />
        </Grid>
        <Grid
          size={{
            xs: 3
          }}>
          <Button
            variant="contained"
            color="primary"
            disabled={ processing || parse_string.length === 0 }
            onClick={parse}>
            Parse
          </Button>
        </Grid>
        <Grid
          size={{
            xs: 12
          }}>
          <div ref={parseRef} dangerouslySetInnerHTML={{ __html: parse_string }}></div>
        </Grid>
      </>
    );
  }

  if (!fetched || loading) {
    const height = window.innerHeight - 81;
    return (<LoadingBox size={height * 0.5} height={height} width={window.innerWidth - 1} />);
  } else if (navigateTo !== null) {
    return <Navigate to={navigateTo} />;
  } else {
    return (
      <Grid container spacing={0} direction="row">
        <Grid size={12}>
          <Tooltip title={`Back to Spells`}>
            <Fab size="small" color="primary" style={{marginLeft: "8px"}}
              onClick={ () => {
                setNavigateTo(`/spell`);
              }}>
              <ArrowBack/>
            </Fab>
          </Tooltip>&nbsp;
          <span className="header">
            Parse Spells
          </span>
        </Grid>
        { processing &&
          <Grid
            className="centered"
            size={12}>
            <LoadingBox message={processing_message} height={200} />
          </Grid>
        }
        <Grid size={12}>
          <SelectSourceBookBox 
            name="Spell List Source Book"
            type={sl_sb_type}
            id={sl_sb_id}
            onChange={(type, id) => {
              setSLSBType(type);
              setSLSBId(id);
            }}
          />
        </Grid>
        { !processing && !complete && 
          <>
            { spells.length > 0 ? renderSpells() : renderParser() }
          </>
        }
        { complete &&
          <Grid size={12}>
            <StringBox
              name="Log"
              value={final_report.join("\r\n")}
              multiline
            />
          </Grid>
        }
      </Grid>
    );
  }
}
